import { render } from "./ModalNewPlatformOrder.vue?vue&type=template&id=4370c4a1"
import script from "./ModalNewPlatformOrder.vue?vue&type=script&lang=js"
export * from "./ModalNewPlatformOrder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__